import { Botao } from '../../componentes/Botao.js';
import { DesenhoDaEtiqueta } from './DesenhoDaEtiqueta.js';
import type { TamanhoDeEtiqueta } from './etiqueta.js';
import type { EstadoDoQr } from './useQrDosProdutos.js';
import './PreviaDasEtiquetas.css';

type Props = {
  readonly codigos: readonly string[];
  readonly estados: ReadonlyMap<string, EstadoDoQr>;
  readonly tamanho: TamanhoDeEtiqueta;
  readonly aoRemover: (codPro: string) => void;
  readonly aoTentarDeNovo: (codPro: string) => void;
};

/**
 * Um cartão por produto, na ordem da lista, com a etiqueta como vai sair.
 *
 * Cada cartão conta o próprio desfecho: gerando, recusado (com "Tentar de
 * novo") ou pronto. Um código recusado não esconde os outros.
 */
export function PreviaDasEtiquetas({
  codigos,
  estados,
  tamanho,
  aoRemover,
  aoTentarDeNovo,
}: Props) {
  return (
    <ul className="previa-etiquetas" aria-label="Etiquetas da impressão">
      {codigos.map((codPro) => (
        <li key={codPro} className="previa-etiquetas__cartao">
          <Conteudo
            codPro={codPro}
            estado={estados.get(codPro)}
            tamanho={tamanho}
            aoTentarDeNovo={aoTentarDeNovo}
          />
          <Botao
            variante="discreto"
            altura="pequena"
            aria-label={`Remover ${codPro}`}
            onClick={() => {
              aoRemover(codPro);
            }}
          >
            Remover
          </Botao>
        </li>
      ))}
    </ul>
  );
}

function Conteudo({
  codPro,
  estado,
  tamanho,
  aoTentarDeNovo,
}: {
  readonly codPro: string;
  readonly estado: EstadoDoQr | undefined;
  readonly tamanho: TamanhoDeEtiqueta;
  readonly aoTentarDeNovo: (codPro: string) => void;
}) {
  if (estado?.situacao === 'pronto') {
    return <DesenhoDaEtiqueta tamanho={tamanho} qr={estado.qr} />;
  }

  if (estado?.situacao === 'falhou') {
    return (
      <div className="previa-etiquetas__falha" role="alert">
        <p>
          <span className="previa-etiquetas__codigo">{codPro}</span> — {estado.mensagem}
        </p>
        <Botao
          altura="pequena"
          onClick={() => {
            aoTentarDeNovo(codPro);
          }}
        >
          Tentar de novo
        </Botao>
      </div>
    );
  }

  return (
    <p className="previa-etiquetas__espera" role="status">
      Gerando o QR de <span className="previa-etiquetas__codigo">{codPro}</span>…
    </p>
  );
}
